module.exports = __webpack_public_path__ + "static/media/splash.42c7db82.png";